module.exports = __webpack_public_path__ + "assets/images/project/down-arrow.svg?v=f8355a24";